import React, { lazy, useMemo } from "react";

import { useFeatureFlag } from "fond/featureFlags";
import { RoutedTabs, TabDefinition } from "fond/widgets/RoutedTabs";

import { SettingsTabContent } from "../common.styles";

const AccountDetailsTab = lazy(() => import("./AccountDetails"));
const SubscriptionDetailsTab = lazy(() => import("./SubscriptionDetails"));
const AccountDefaultsTab = lazy(() => import("./AccountDefaults"));
const SecurityTab = lazy(() => import("./Security"));

const AccountManagement: React.FC = () => {
  const { value: isMfaEnabled } = useFeatureFlag("security_mfa", false);

  const tabs: TabDefinition[] = useMemo(() => {
    const baseTabs: TabDefinition[] = [
      { label: "Details", path: "details", component: AccountDetailsTab, event: "settings.account.details.viewed" },
      { label: "Subscription", path: "subscription", component: SubscriptionDetailsTab, event: "settings.account.subscription.viewed" },
      { label: "Defaults", path: "defaults", component: AccountDefaultsTab, event: "settings.account.defaults.viewed" },
    ];

    if (isMfaEnabled) {
      baseTabs.push({ label: "Security", path: "security", component: SecurityTab, event: "settings.account.security.viewed" });
    }

    return baseTabs;
  }, [isMfaEnabled]);

  return <RoutedTabs ContentContainer={SettingsTabContent} prefix="/settings/account" tabs={tabs} data-testid="account-management" />;
};

export default AccountManagement;
